<template>
  <div class="student-pay">
    <div v-if="!paid">
      <div class="head">
        <div class="name">{{ name }}</div>
        <div class="img">
          <img :src="avatar" alt />
        </div>
      </div>
      <div class="msg">
        <div class="item">
          <div class="item-name">练车金额</div>
          <div class="item-value">￥{{ total_amount }}</div>
        </div>
        <div class="item">
          <div class="item-name">累计学时</div>
          <div class="item-value">{{ total_duration }}</div>
        </div>
      </div>
      <button class="pay-btn" @click="pay">
        赞赏
        <i
          v-if="paying"
          class="weui-loading"
          style="width: 25px; height: 25px; margin-left: 0.1rem"
        ></i>
      </button>
      <div class="pay-agree">
        <div class="wrap">
          <div
            class="pay-agree_select"
            @click="selectHandle"
            :class="isSelect ? 'selected' : ''"
          >
            <div class="success"></div>
          </div>
        </div>
        <div style="width: 6.5rem" @click="selectHandle">
          <div class="pay-agree_title">
            我已阅读并同意
            <span style="color: #0093f0" @click="goDetail"
              >《路考仪学员协议》</span
            >
          </div>
          <div class="pay-agree_content">
            使用路考仪练车，是学员自愿行为。若有任何强制行为，
            请与我们反应或投诉，客服热线：
            <a style="color: #0093f0" href="tel:13127832213">13127832213</a>
          </div>
        </div>
      </div>
      <div class="insure" v-if="bannerImg">
        <img :src="bannerImg" alt @click="toInsure" />
      </div>
    </div>
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="massage"></dialog-item>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "weui";
import weui from "weui.js";
import { payUrl, hostUrl, walletUrl } from "../http/env.js";
import _wx from "../../static/js/chelun-wx-1.1.js";
import {
  unpaidById,
  pushStudentOrder,
  isShengPay,
  pay,
  depositBanner,
  getAdCode,
} from "@/http/api";
import { setTimeout } from "timers";
import dialogItem from "./dialog";
import store from "../pages/advise/store";

export default {
  props: ["studentId", "softSn", "openid"],
  components: {
    "dialog-item": dialogItem,
  },
  data() {
    return {
      showDialog: false,
      public_path: process.env.PUBLICK_PATH,
      paying: false,
      paid: false,
      name: "",
      total_amount: 0,
      total_duration: 0,
      avatar: "",
      serialnumber: "",
      channel: "",
      student_id: "",
      soft_sn: "",
      checkVal: "",
      isSelect: false,
      bannerImg: "",
      bannerUrl: "",
      coach_id: "",
      orderList: [],
      is_trackplay: 0,
      trackplay_obj: {},
      ad_code: "",
      is_shengPay: 0,
    };
  },

  methods: {
    isShengPay() {
      let data = {
        soft_sn: this.soft_sn,
        student_id: this.student_id,
      };
      isShengPay(data).then((res) => {
        if (res.code === 0) {
          this.is_shengPay = res.data.is_shengPay;
        }
      });
    },
    getCurrentAdCode() {
      getAdCode({ student_id: this.student_id }).then((res) => {
        if (res.code == 0) {
          this.ad_code = res.data.ad_code || "";
          let data = {
            bannerType: 104,
            ad_code: res.data.ad_code || "",
          };
          this.getBanner(data);
        }
      });
    },
    getBanner(data) {
      depositBanner(data).then((res) => {
        console.log(res);
        if (res.data.list.length > 0) {
          this.bannerImg = res.data.list[0].imageUrl || "";
          this.bannerUrl = res.data.list[0].url || "";
        }
      });
    },
    selectHandle() {
      this.isSelect = !this.isSelect;
      store.checked = this.isSelect;
    },
    showDia(massage) {
      this.showDialog = true;
      this.massage = massage;
      setTimeout(() => {
        this.showDialog = false;
        this.massage = "";
      }, 1500);
    },
    toInsure() {
      // window.location.href = `${hostUrl}/frontend/insure-order`;
      window.location.href = this.bannerUrl;
    },
    go_pay() {
      unpaidById({
        student_id: this.student_id,
        soft_sn: this.soft_sn,
      })
        .then((res) => {
          console.log(res);
          this.avatar = res.data.avatar;
          this.name = res.data.name;
          this.total_amount = res.data.total_amount;
          this.total_duration = res.data.total_duration;
          this.is_trackplay = res.data.is_trackplay;
          if (this.is_trackplay == 1) {
            this.trackplay_obj = res.data.list[0];
          }
          let detail = [];
          let payType = "2";
          let list = res.data.list;
          for (let i = 0; i < list.length; i++) {
            let item = { id: list[i].order_id };
            detail.push(item);
          }
          this.orderList = detail;
          if (list.length) {
            this.coach_id = list[0].coach_id;
          }
          if (_wx.isWx) {
            payType = "1";
          } else {
            payType = "2";
          }
          let channel;
          // 优先检查是否使用盛付通支付
          if (this.is_shengPay === 1) {
            if (_wx.isWx) {
              channel = "shengpay_mp";
            } else {
              channel = "shengpay_ali";
            }
          } else if (_wx.isWx) {
            channel = "weixin_mp";
          } else {
            channel = "alipay";
          }
          let _obj = {};
          _obj.soft_sn = this.softSn; // 软件编号
          _obj.coach_id = res.data.list[0].coach_id; // 教练id
          _obj.student_id = this.studentId; // 学员id
          _obj.pay_type = payType; // 1微信 2支付宝 9微信小程序
          _obj.amount = this.total_amount; // 金额
          _obj.pay_platform = "wap"; // 支付平台 (h5支付wap, 小程序app)
          _obj.channel = channel;
          _obj.detail = JSON.stringify(detail);
          pushStudentOrder(_obj).then((res) => {
            console.log(res);
            if (res.code === 0) {
              this.serialnumber = res.data.data.serial_number;
            }
          });
        })
        .catch((err) => {
          this.showDia("请求失败，请检查网络后重试");
        });
    },
    pay() {
      if (this.paying) {
        return;
      } else if (!this.isSelect) {
        this.showDia("请阅读并同意使用须知");
        return;
      } else if (this.orderList.length == 0) {
        this.showDia("该账号暂无欠费订单！");
        return;
      } else {
        this.paying = true;
        setTimeout(() => (this.paying = false), 5000);
        // 优化后的代码 - 使用清晰的逻辑判断
        let channel;
        // 优先检查是否使用盛付通支付
        if (this.is_shengPay === 1) {
          if (_wx.isWx) {
            channel = "shengpay_mp";
          } else {
            channel = "shengpay_ali";
          }
        } else if (_wx.isWx) {
          channel = "weixin_mp";
        } else {
          channel = "alipay";
        }
        // let callbackUrl = `${hostUrl}/h5/deposit-succeed?type=1`;
        window.sessionStorage.setItem(
          "orderId",
          this.orderList.length ? this.orderList[0].id : ""
        );
        let callbackUrl = encodeURIComponent(
          `${hostUrl}/mobile/pay-success?ad_code=${this.ad_code}&orderId=${
            this.orderList.length ? this.orderList[0].id : ""
          }`
        );
        // 支付成功跳转轨迹回放
        // if(this.is_trackplay == 1 && this.soft_sn == 'S22208'){
        //   let url = ''
        //   if(this.trackplay_obj.subject_type == 2){
        //     url =  'https://clto.cc/cc2FcewT'
        //   }else if(this.trackplay_obj.subject_type == 3){
        //     url = 'https://clto.cc/xtkFcewn'
        //   }
        //   let student_id = this.trackplay_obj.student_id
        //   let type = this.trackplay_obj.is_hp == 1 ? 0 : 1
        //   let subject_type = this.trackplay_obj.subject_type
        //   let order_id = this.trackplay_obj.order_id
        //   let params=`?mobile=${student_id}&type=${type}&subject_type=${subject_type}&order_id=${order_id}`
        //   callbackUrl = encodeURIComponent(url + params)
        // }
        pay({
          c: "order",
          v: "pay2",
          serial_number: this.serialnumber,
          channel: channel,
          openid: this.openid,
          callback_url: callbackUrl,
        })
          .then((res) => {
            this.paying = false;
            console.log(res.data, "data");
            // 优化后的支付处理逻辑 - 使用switch语句提高可读性
            switch (channel) {
              case "shengpay_ali":
                // 盛付通支付宝支付
                window.location.href = res.data.payInfo;
                break;

              case "shengpay_mp":
                // 盛付通微信公众号支付
                this.handleWechatPay(res.data.payInfo, callbackUrl);
                break;

              default:
                // 其他支付方式处理
                if (_wx.isWx) {
                  // 普通微信环境支付
                  this.handleWechatPay(
                    res.data.order_param,
                    res.data.order_param.callback_url
                  );
                } else {
                  // 默认其他支付方式
                  window.location.href = res.data.url;
                }
            }
          })
          .catch((err) => {
            console.log(err);
            this.paying = false;
            this.showDia("请求失败，请检查网络后重试");
          });
      }
    },
    // 添加辅助方法用于统一处理微信支付逻辑
    handleWechatPay(payInfo, redirectUrl) {
      _wx.pay(payInfo, () => {
        window.location.href = decodeURIComponent(redirectUrl);
      });
    },
    goDetail() {
      this.$router.push({ name: "advise" });
    },
  },
  created() {
    this.isSelect = store.checked;
  },
  mounted() {
    this.student_id = sessionStorage.student_id;
    this.soft_sn = sessionStorage.soft_sn;
    console.log(this.student_id, this.soft_sn);
    this.go_pay();
    this.getCurrentAdCode();
    this.isShengPay();
  },
};
</script>

<style lang="scss" scoped>
.student-pay {
  padding: 0 0.3rem;
  .head {
    width: 100%;
    height: 2.4rem;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    .name {
      flex: 1;
      font-size: 0.48rem;
      font-weight: 500;
    }
    .img {
      flex: 1;
      text-align: right;
      img {
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 0.8rem;
        float: right;
        border: 0.1rem solid #fff;
        box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
      }
    }
  }
  .msg {
    .item {
      display: -webkit-flex;
      display: flex;
      font-size: 0.32rem;
      height: 0.9rem;
      align-items: center;
      &:first-child {
        border-bottom: 1px solid #e6e6e6;
      }
      .item-name {
        flex: 1;
        text-align: left;
        color: rgba(64, 64, 64, 0.6);
      }
      .item-value {
        flex: 1;
        text-align: right;
      }
    }
  }
  .pay-btn {
    width: 100%;
    display: block;
    // margin: auto;
    height: 0.88rem;
    background: rgba(0, 147, 240, 1);
    border: 1px solid rgba(229, 229, 229, 1);
    color: #fff;
    font-size: 0.34rem;
    margin-top: 1.2rem;
  }
  .pay-agree {
    display: flex;
    margin-top: 0.4rem;
    .wrap {
      height: calc(0.32rem * 1.6);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &_select {
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 6rem;
      // margin-top: 0.02rem;
      margin-right: 0.15rem;
      border: 1px solid #666;
      display: flex;
      justify-content: center;
      align-items: center;
      .success {
        width: 0.06rem;
        height: 0.12rem;
        margin-top: -0.03rem;
        // border-width: 0 0.03rem 0.05rem 0;
        border-right: 0.03rem solid #fff;
        border-bottom: 0.03rem solid #fff;
        transform: rotate(45deg);
      }
    }
    .selected {
      border-color: #fff;
      background-color: #0093f0;
    }
    &_title {
      font-size: 0.32rem;
      color: rgba(0, 0, 0, 1);
    }
    &_content {
      font-size: 0.26rem;
      color: rgba(24, 24, 25, 0.7);
    }
  }
}
.insure {
  margin-top: 1.2rem;
  padding-bottom: 1.2rem;
  img {
    width: 100%;
    height: auto;
    box-shadow: 0px 2px 12px 0px rgba(160, 160, 160, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studentPay.vue